var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[(!_vm.appFetchingError)?_c('div',{staticClass:"apps-container"},_vm._l((_vm.contents),function(c){return _c('v-card',{key:c.uuid,attrs:{"app":c}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }